import React, { Component } from 'react';
import '@/assets/styles/pages/login/OTP.scss';
import Tips from '@/components/Tips/Tips';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PARAMS as requestParams } from '@/constants/params';
import { loginAction,otpRegisterAction,otpTicketVerifyAction } from '@/actions/auth';
import { SERVICES_RESP as servicesResp,Icons } from '@/configurations';
import { getSafe } from '@/helpers/global';
import { PATH } from '@/constants/paths';
import { STORAGE_KEY } from '@/constants/storage.key';
import { getSafeStorage, saveSafeStorage } from '@/helpers/global';
class OTP extends Component {
    constructor(props) {
        super(props);
        this.cancelOTPRegistered = this.cancelOTPRegistered.bind(this);
        this.confirm = this.confirm.bind(this);
        this.state = {
            OTPCode:'',
            isOTPRegistrationPage:true,
            isShowTips:false,
            isSuccessTips:false,
            tipsMessage: '',
            showCancelButton:true,
            isLoading:false,
            OTPRegisterVerifySuccess:false,
            historyData:[],
            otp: [
              { id: 1, ref: React.createRef(), value: '' },
              { id: 2, ref: React.createRef(), value: '' },
              { id: 3, ref: React.createRef(), value: '' },
              { id: 4, ref: React.createRef(), value: '' },
              { id: 5, ref: React.createRef(), value: '' },
              { id: 6, ref: React.createRef(), value: '' },
          ],
          index:'0'
        }
    }

    enterPress = (e) => {
        if ((e.keyCode || e.which) === 13) {
          this.confirm()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keypress', this.enterPress)
      }

    componentDidMount(){
        const {language} = this.props;
        const otpVerifcationNotYetTip = language.otp_verifcation_not_yet_tip;
        let historyData = getSafeStorage(STORAGE_KEY.REMEMBER_ME);
        document.addEventListener('keypress', this.enterPress);
        if(historyData){
            this.setState({
                tipsMessage:otpVerifcationNotYetTip,
                historyData:JSON.parse(historyData)
            })
        }else{
            this.setState({
                tipsMessage:otpVerifcationNotYetTip
            })
        }
    }

    componentDidUpdate(preProxy){
        const {language} = this.props;
        const {isOTPRegistrationPage} = this.state;
        if(preProxy.language !== language){
            if(isOTPRegistrationPage){
                const otpVerifcationNotYetTip = language.otp_verifcation_not_yet_tip;
                this.setState({
                    tipsMessage:otpVerifcationNotYetTip
                })
            }
        }
    }

    render() { 
        const {language,loginData} = this.props;
        const {OTPCode,isOTPRegistrationPage,isShowTips,isSuccessTips,tipsMessage,showCancelButton,isLoading,OTPRegisterVerifySuccess,otp} = this.state;

        return (  
            <div className='OTP'>
                <div className="OTP-box">
                    <div className="OTP-title-box">
                        {getSafe(() => language.otp_registration_verification)}
                    </div>
                    {isShowTips &&<Tips isSuccess={isSuccessTips}>{tipsMessage}</Tips>}
                    <div className='registration-verification-form'>
                        <div className="prompt-text">{getSafe(() => language.input_otp_tip)}</div>
                        <div className='otp-container'>
                        {otp.map((item,index) =>
                            <div key={`otp-${item.id}`} className={item.id - 1  === this.state.index ? 'otp-number otp-focus' : 'otp-number'}>
                                <input type='text'
                                    autoFocus={item.id === 1}
                                    pattern='[0-9]'
                                    onKeyDown={(e) => this.handleKeyDown(e, item.id - 1)}
                                    onInput={(e) => this.handleChange(e, item)}
                                    ref={item.ref}
                                    value={getSafe(() => item.value, item.id)} />
                            </div>
                        )}
                    </div>
                    </div>
                    <div className='button-box'>
                        {showCancelButton && <button className='flex-items-center cancal-button' onClick = {this.cancelOTPRegistered}>
                            {getSafe(() => language.common_cancel)}
                        </button>}
                        <button disabled={isLoading} 
                            className={OTPRegisterVerifySuccess ? 'flex-items-center confirm-button OTPRegisterVerifySuccess-confirm-button' : 'flex-items-center confirm-button'}
                            onClick = {this.confirm} >
                            {isLoading ? <Icons.Loading /> : getSafe(() => language.common_confirm)}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    OTPInput(){
        let inputLength = this.OTPInputValue.value.length;
        if(inputLength > 8){
            this.setState({
                OTPCode:this.state.OTPCode
            })
        }else{
            this.setState({
                OTPCode:this.OTPInputValue.value
            })
        }
    }
    handleKeyDown = (evt, index) => {
      if (evt.key === 'Backspace') {
          evt.preventDefault();
          let newOTP = [...this.state.otp];
          newOTP[index].value = '';
          this.setState({ otp: newOTP,index:index-1 }, () => {
              if (index > 0) {
                  const input = this.state.otp[index - 1].ref.current;
                  input.focus();
                  input.select();
              }
          })
      }
  }

  handleChange = (evt, item) => {
      if (evt.target.validity.valid) {
          let newOTP = [...this.state.otp];
          newOTP[item.id - 1].value = evt.target.value;
          this.setState({ otp: newOTP,index:item.id }, () => {
              if (item.id < 6) {
                  this.state.otp[item.id].ref.current.focus();
              }
              let isFillOTP = this.state.otp.every(item => item.value !== '');
          })
      }
  }
    cancelOTPRegistered(){
        this.props.cancelOTPRegistered()
    }
    confirm(){
      const otpValue = this.state.otp.reduce((acc, current) => {
        acc.push(current.value);
        return acc;
      }, []);
      let OTPCode = otpValue.join('')
      const {language, loginData } = this.props;
      if (OTPCode === '' || OTPCode === null || OTPCode.length !== 6){
        this.setState({
          isShowTips:true,
          tipsMessage:getSafe(() => language.input_otp_tip)
        })
        return
      }else{
        this.setState({
          isShowTips:false,
          isLoading:true,
          tipsMessage:''
        })
        let params = {
          [requestParams.LOGIN_ID]: loginData.loginID,
          [requestParams.OTP_TICKET]: loginData.otpTicket,
          [requestParams.OTP_CODE]:OTPCode,
          [requestParams.LANGUAGE]:language.lang,
          [requestParams.TRADING_ACC_SEQ]: '1'
        };
        this.props.otpRegisterVerifyAction(params,res => {
          this.setState({
            isLoading:false
          })
          if (res.errorCode === servicesResp.SUCCESS_CODE) {
            if (loginData.remember) {
              let historyData = this.state.historyData
              for (let i = 0; i < historyData.length; i++) {
                if (historyData[i].loginId === loginData.loginID) {
                  historyData[i].password = loginData.password
                  saveSafeStorage(STORAGE_KEY.REMEMBER_ME, JSON.stringify(historyData))
                  this.props.history.push(PATH.TRADE)
                  return
                }
              }
              historyData.push({
                loginId: loginData.loginId,
                password: loginData.password,
              })
              saveSafeStorage(STORAGE_KEY.REMEMBER_ME, JSON.stringify(historyData))
            }
            this.setState({
              isLoading: false,
              tipsMessage: ''
            }, () => {
              this.props.history.push(PATH.TRADE)
            })
          }else{
            this.setState({
              isShowTips:true,
              OTPCode:'',
              tipsMessage:getSafe(() => language.otp_incorrect)
            })
            let newOTP = [...this.state.otp];
            newOTP.map((item) => item.value = '');
            this.setState({ otp: newOTP })
            const input = this.state.otp[0].ref.current;
            input.focus();
            input.select();
          }
        })
      }
    }
}
 
export default withRouter(connect(
    state => ({
      language: state.app.language
    }),
    dispatch => ({
        otpRegisterAction: (p, c) => dispatch(otpRegisterAction(p, c)),
        otpRegisterVerifyAction: (p, c) => dispatch(otpTicketVerifyAction(p, c)),
        loginAction: (p, c) => dispatch(loginAction(p, c))
    })
)(OTP))